import api from '~/api';
import axios from 'shared/libs/axios';

export type selectionType = {
  slctnPblancNm : string,
  page? : number,
  itemsPerPage? : number,
  createDt? : Date,
}


//사업선정목록 가져오기
export default (data:selectionType) =>
api({
  method: 'get',
  url: `${process.env.REACT_APP_DOMAIN_PMS_BNET}/pms/api/front/slctn-pblanc`,
  params: data,   
})

export const fetchAnnouncementSelectionResDetail = (pblancId:string) =>
  api({
    method: 'get',
    url: `${process.env.REACT_APP_DOMAIN_PMS_BNET}/pms/api/front/slctn-pblanc/${pblancId}`,
  })

// 파일다운로드(단건)
export const fetchDownloadFile = async (slctnPblancId: string, attachmentId: string) => {
  const url = `${process.env.REACT_APP_DOMAIN_PMS_BNET}/pms/api/front/slctn-pblanc/${slctnPblancId}/atchmnfl/${attachmentId}`;
  const response = await axios({
    method: 'get',
    url,
    responseType: 'blob',
  });

  // 파일명 추출 (헤더에서 또는 기본값)
  let fileName = 'downloaded-file';
  const disposition = response.headers['content-disposition'];
  if (disposition && disposition.indexOf('filename=') !== -1) {
    fileName = decodeURIComponent(disposition.split('filename=')[1].replace(/"/g, ''));
  }

  const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = blobUrl;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
};

// 파일다운로드(전체)
export const fetchAllDownloadFile = (slctnPblancId: string) => {
  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_DOMAIN_PMS_BNET}/pms/api/front/slctn-pblanc/${slctnPblancId}/atchmnfl`,
  });
};